export default __webpack_public_path__ + "static/media/432hz-inner-healing.42a45389.ogg";